import { render, staticRenderFns } from "./TrueOrFalseQuestions.vue?vue&type=template&id=888f2a0a&scoped=true&lang=html&"
import script from "./TrueOrFalseQuestions.vue?vue&type=script&lang=js&"
export * from "./TrueOrFalseQuestions.vue?vue&type=script&lang=js&"
import style0 from "./TrueOrFalseQuestions.vue?vue&type=style&index=0&id=888f2a0a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888f2a0a",
  null
  
)

export default component.exports